import { UserNote } from '@/types/UserNote';
import toast from 'react-hot-toast';
import { setUserNote } from 'utils/useZStore';
import { createBrowserClientSupa } from './supabase/createBrowserClient';
import localforage from 'localforage';
import { getUserNotesFromLocal, LOCAL_USER_NOTES_KEY } from './get-user-notes';
import { SupabaseClient } from '@supabase/supabase-js';

const updateNoteInLocalStorage = async (newUserNote: UserNote) => {
  const { data: userNotes, error } = await getUserNotesFromLocal();
  const newUserNotes = { ...userNotes, [newUserNote.example_id]: newUserNote };
  if (error) {
    toast.error('Error updating example.');
  }
  // TO-DO: Capture errors in this operation
  await localforage.setItem(LOCAL_USER_NOTES_KEY, newUserNotes);
};

// TO-DO: We should type supabase
const updateNoteInSupabase = async (
  newUserNote: UserNote,
  supabase: SupabaseClient<any, 'public', any>,
) => {
  const { error } = await supabase.from('user_notes').upsert(newUserNote);
  if (error) {
    console.error(error);
    toast.error('Error bookmarking example.');
  }
};

export const updateUserNote = async (newUserNote: UserNote) => {
  setUserNote(newUserNote);
  const supabase = createBrowserClientSupa();
  // TO-DO: There must be a faster way to decide if the user is logged in
  const { data } = await supabase.auth.getSession();

  // TO-DO: Can we not abstract this logic so that it's taken care by the same
  // function, would something like react-query help us here?
  if (data.session) {
    updateNoteInSupabase(newUserNote, supabase);
  } else {
    updateNoteInLocalStorage(newUserNote);
  }
};
